import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../store/hooks";
import { AllComponents } from "./interfaces/base";
import { getComponentFromStructureMap } from "./utilities/componentIdentity";

type Props = {
  componentKey?: string | null;
};

const BackgroundVideoComponent = React.memo(({ componentKey }: Props) => {
  const component = useAppSelector((state) =>
    getComponentFromStructureMap(state.builder.structure.components, componentKey)
  ) as AllComponents | undefined;

  const backgroundVideo = component?.attributes?.backgroundVideo;

  const [selectedTopPosition, setSelectedTopPosition] = useState(
    backgroundVideo?.topPosition ?? "50"
  );

  const [selectedExtension, setSelectedExtension] = useState(
    backgroundVideo?.extension ?? "mp4"
  );

  const [selectedLeftPosition, setSelectedLeftPosition] = useState(
    backgroundVideo?.leftPosition ?? "50"
  );
  const [selectedWidthPosition, setSelectedWidthPosition] = useState(
    backgroundVideo?.width ?? "120"
  );
  const [selectedHeightPosition, setSelectedHeightPosition] = useState(
    backgroundVideo?.height ?? "120"
  );
  const [selectedAutoplay, setSelectedAutoplay] = useState<boolean>(
    backgroundVideo?.autoplay ?? true
  );
  const [selectedLoop, setSelectedLoop] = useState<boolean>(
    backgroundVideo?.loop ?? true
  );
  const [selectedMuted, setSelectedMuted] = useState<boolean>(
    backgroundVideo?.muted ?? true
  );

  const [selectedControls, setSelectedControls] = useState<boolean>(
    backgroundVideo?.controls ?? true
  );

  const [selectedLazyLoad, setSelectedLazyLoad] = useState<boolean>(
    backgroundVideo?.lazyLoad ?? false
  );

  useEffect(() => {
    if (!component) {
      return;
    }
    const bv = component.attributes.backgroundVideo;
    setSelectedTopPosition(bv?.topPosition ?? "50");
    setSelectedLeftPosition(bv?.leftPosition ?? "50");
    setSelectedWidthPosition(bv?.width ?? "120");
    setSelectedHeightPosition(bv?.height ?? "120");
    setSelectedAutoplay(
      bv?.hasOwnProperty("autoplay") ? Boolean(bv?.autoplay) : true
    );
    setSelectedLoop(bv?.hasOwnProperty("loop") ? Boolean(bv?.loop) : true);
    setSelectedMuted(bv?.hasOwnProperty("muted") ? Boolean(bv?.muted) : true);

    setSelectedControls(
      bv?.hasOwnProperty("controls") ? Boolean(bv?.controls) : false
    );

    setSelectedLazyLoad(
      bv?.hasOwnProperty("lazyLoad") ? Boolean(bv?.lazyLoad) : false
    );

    setSelectedExtension(
      bv?.hasOwnProperty("extension") ? String(bv?.extension) : "mp4"
    );
  }, [component, component?.attributes?.backgroundVideo]);

  if (!component) {
    return null;
  }

  return (
    <div
      style={{
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {component.attributes.backgroundVideo &&
        component.attributes.backgroundVideo.url && (
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",

              top: 0,
              left: 0,
              overflow: "hidden",
              display: "flex",
              justifyContent: "end",
              alignItems: "end",
              zIndex: -1,
            }}
          >
            {selectedExtension === "mp4" && (
              <>
                <video
                  autoPlay={selectedAutoplay}
                  muted={selectedMuted}
                  loop={selectedLoop}
                  style={{
                    zIndex: 999,
                    position: "absolute",
                    top: `${selectedTopPosition}%`,
                    left: `${selectedLeftPosition}%`,
                    width: `${selectedWidthPosition}vw`,
                    height: `
                ${selectedHeightPosition}vh
                
              `,
                    transform: "translate(-50%, -50%)",
                  }}
                  src={component.attributes.backgroundVideo.url}
                />
              </>
            )}

            {(selectedExtension === "youtube" ||
              selectedExtension === "vimeo") &&
              component.attributes.backgroundVideo.extension !== undefined &&
              component.attributes.backgroundVideo.extension !== "mp4" && (
                <iframe
                  loading={selectedLazyLoad ? "lazy" : "eager"}
                  scrolling="no"
                  frameBorder="0"
                  style={{
                    position: "absolute",
                    top: `${selectedTopPosition}%`,
                    left: `${selectedLeftPosition}%`,
                    width: `${selectedWidthPosition}vw`,
                    height: `
                ${selectedHeightPosition}vh
                
              `,
                    transform: "translate(-50%, -50%)",
                  }}
                  allow="fullscreen; picture-in-picture"
                  allowFullScreen
                  src={`${
                    component.attributes.backgroundVideo.url
                  }?api=1&autoplay=${
                    selectedAutoplay === true ? "1" : "0"
                  }&loop=${
                    selectedLoop === true ? "1" : "0"
                  }&byline=0&title=0&muted=${
                    selectedMuted === true ? "1" : "0"
                  }&controls=${
                    component.attributes.backgroundVideo.controls
                  }&playlist=${
                    component.attributes.backgroundVideo.url.split("/embed/")[1]
                  }&mute=${selectedMuted === true ? "1" : "0"}`}
                />
              )}
          </div>
        )}
    </div>
  );
});

export default BackgroundVideoComponent;
